var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card-form',{attrs:{"title":"详情信息"}},_vm._l((_vm.detailData),function(data,index){return _c('qx-detail-box',{key:index,attrs:{"data":data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }